import { useNotification } from '@/components/Notifications/useNotification';
import { TNotification } from '@/types/notifications';
import Alert from 'react-bootstrap/Alert';
import styles from './Notification.module.scss';

export const Notification = ({notification}: {notification: TNotification}) => {
    const {onClose} = useNotification(notification);

    return (
        <Alert variant={notification.variant} dismissible onClose={onClose} className={styles.notification}>
            {notification.text}
        </Alert>
    );
};
